type Props = {
	children?: React.ReactNode
	paragraphs?: string[]
	className?: string
}

export default function SectionInformation({ children, paragraphs, className }: Props) {
	return (
		<div className={`w-full text-white ${className ?? ''}`}>
			{paragraphs &&
				paragraphs.map((p, i) => (
					<p key={i} className="mt-4 first:mt-0">
						{p}
					</p>
				))}
			{children}
		</div>
	)
}
